import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ExpandableItem } from 'src/app/models/menu-item';

export type SubcellClick = Readonly<{ fatherId: string; submenuId: string }>;

@Component({
  selector: 'app-sidenav-cell',
  standalone: false,
  templateUrl: './sidenav-cell.component.html',
  styleUrls: ['./sidenav-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavCellComponent {
  @Output() public cellClickHandler = new EventEmitter<string>();
  @Output() public subcellClickHandler = new EventEmitter<SubcellClick>();

  @Input() public id = '';
  @Input() public text = '';
  @Input() public icon = '';
  @Input() public isSelected = false;

  private _expand: ExpandableItem[] = [];

  public get expand(): ExpandableItem[] {
    return this._expand;
  }

  @Input() public set expand(value: ExpandableItem[] | undefined) {
    this._expand = value ?? [];
  }

  public get visibleItems(): ExpandableItem[] {
    return this._expand.filter((it) => it?.visible !== false);
  }

  /** Main cell click (no mutar isSelected ací; que ho controle el pare/service). */
  public sidenavClicked(): void {
    this.cellClickHandler.emit(this.id);
  }

  /** Submenu click: emet pare + fill (i evita que dispare el click del header). */
  public subSidenavClicked(submenuId: string, ev: MouseEvent): void {
    ev.stopPropagation();
    this.subcellClickHandler.emit({ fatherId: this.id, submenuId });
  }

  public trackById(_index: number, item: ExpandableItem): string {
    return item.id;
  }
}
